<template>
  <div>
    <v-container grid-list-xl fluid class="px-8 py-4">
      <div class="mb-3">
        <h1 class="fs-18 lh-18 text-uppercase mt-1 font-weight-700">
          History Request
        </h1>
        <v-breadcrumbs class="px-0 py-2" :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            History Request
          </h1>
        </v-col>
        <v-col cols="12" sm="auto" class="px-0">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" icon medium v-on="on">
                <v-icon
                  @click="refresh"
                  color="bluedarken"
                  class="icon-bold icon-large"
                  large
                >
                  mdi-refresh
                </v-icon>
              </v-btn>
            </template>
            <span>
              Refresh
            </span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-card class="elevation-card rounded-10">
        <v-card-title>
          <v-col sm="4" class="pl-0 py-0">
            <v-text-field
              class="pt-0 mt-0"
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search by Subject"
              single-line
              hide-details
              solo
              dense
              @keyup="searchData()"
            ></v-text-field>
          </v-col>
          <v-spacer />
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            :options.sync="options"
            :must-sort="true"
            :server-items-length="totalItems"
            :sort-desc.sync="descending"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 25]
            }"
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            ></v-progress-linear>
            <template v-slot:no-data>
              <label>No data displayed</label>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { formatDate } from '@/utils/helpers';
import ACLMixin from '@/mixins/ACLMixin';
import paginationMixin from '@/mixins/paginationMixin';

export default {
  mixins: [ACLMixin, paginationMixin],
  components: {
    // VuePerfectScrollbar
  },
  props: ['id'],
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    columnActive: [],
    breadcrumbs: [
      {
        text: 'SSHCP',
        disabled: true,
        to: '/sshcp/'
      },
      {
        text: 'History Request',
        disabled: true,
        to: '/sshcp/request'
      }
    ],
    totalItems: 0,
    descending: true,
    sort: '',
    options: {
      sortBy: ['created_at'],
      itemsPerPage: 10,
      page: 1
    },
    loadingDetail: false,
    filter: null,
    loading: false,
    dialog: false,
    headers: [
      {
        text: 'Time',
        align: 'left',
        value: 'created_at',
        tdClass: 'text-capitalize'
      },
      {
        text: 'Subject',
        align: 'left',
        value: 'subject'
      },
      {
        text: 'Description',
        align: 'left',
        value: 'description'
      },
      {
        text: 'HCP Code',
        align: 'left',
        value: 'hcp_code',
        tdClass: 'text-capitalize'
      }
    ],
    detail: {},
    items: [],
    search: '',
    isSearch: false
  }),
  computed: {},
  async mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.getData();
    },
    searchData() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    async getData() {
      this.loading = true;
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      const search = {
        subject: this.search,
        description: this.search,
        hcp_code: this.search
      };
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      return this.$store
        .dispatch('sshcp/getRequestLogs', {
          page,
          limit: itemsPerPage,
          search,
          sort,
          orderBy: 'created_at'
        })
        .then(data => {
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Failed!', err.message.text_en, 'error');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-tr {
  cursor: pointer;

  &:hover {
    background: #dfdfdf;
  }
}

.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table {
  border-right: 0 !important;
  border-bottom: 0 !important;
}
.v-data-table.table-taxonomy.nav-table td {
  height: 35px !important;
}
.v-data-table.table-taxonomy.nav-table.sshcf-table thead,
.v-data-table.table-taxonomy.nav-table.sshcf-table td:last-child {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>
